import { LANGUAGES_FOR_LOCATIONS } from '@v2/commons/config'

export const getNetChangesBetweenObjects = <
  V extends {},
  PV extends Partial<V>,
>(
  values: V,
  prevValues: PV,
): Partial<V> => {
  return Object.keys(values).reduce((changedFields, key) => {
    const typedKey = key as keyof V
    const originalValue = prevValues[typedKey]
    const newValue = values[typedKey]

    if (originalValue?.toString() !== newValue?.toString()) {
      return {
        ...changedFields,
        [typedKey]: newValue,
      }
    }
    return changedFields
  }, {})
}

export const transformLabelsToValuesforLanguages = (labels: string[]) => {
  return labels
    .map((label: string) => {
      const language = LANGUAGES_FOR_LOCATIONS.find(
        (lang) => lang.label === label,
      )
      return language ? language.value : null
    })
    .filter((value) => value !== null)
}

export const transformValuesToLabelforLanguages = (values: string[]) => {
  return values
    .map((value: string) => {
      const language = LANGUAGES_FOR_LOCATIONS.find(
        (lang) => lang.value === value,
      )
      return language ? language.label : null
    })
    .filter((value) => value !== null)
}

export const transformValuesToLabelforLanguagesToString = (
  values: string[],
) => {
  return values
    .map((value: string) => {
      const language = LANGUAGES_FOR_LOCATIONS.find(
        (lang) => lang.value === value,
      )
      return language ? language.label : null
    })
    .filter((value) => value !== null)
    .join(', ')
}
